import axios from "axios";
const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
export const tableHeadForExcel = [
  "Sno",
  "reportDate",
  "section",
  "Direction",
  "From_Station",
  "To_Station",
  "Section_Yard",
  "Corridore",
  "Department",
  "Type",
  "Block_Type",
  "No_Of_Demand_By_Engg",
  "Engg_Demand",
  "No_Of_Demand_Agreed_GIVEN",
  "Agreed_Demand",
  "GrantedFrom",
  "GrantedTo",
  "Granted_Duration",
  "Availed_From",
  "Availed_To",
  "Availed",
  "Burst",
  "Actual_Output_in_Meter",
  "Actual_Output",
  "Remarks",
  "Reason",
  "Rolling_Block",
];
export const tableHeadForExcelStationCode = [
  "Sno",
  "reportDate",
  "section",
  "Direction",
  "From_Station_code",
  "To_Station_Code",
  "Section_Yard",
  "Corridore",
  "Department",
  "Type",
  "Block_Type",
  "No_Of_Demand_By_Engg",
  "Engg_Demand",
  "No_Of_Demand_Agreed_GIVEN",
  "Agreed_Demand",
  "GrantedFrom",
  "GrantedTo",
  "Granted_Duration",
  "Availed_From",
  "Availed_To",
  "Availed",
  "Burst",
  "Actual_Output_in_Meter",
  "Actual_Output",
  "Remarks",
  "Reason",
  "Rolling_Block",
];

export const columnWidths = {
  Id: "60px",
  Date: "100px",
  Section: "100px",
  Direction: "100px",
  From_Station: "120px",
  To_Station: "120px",
  Section_Yard: "60px",
  Corridore: "100px",
  Department: "100px",
  Type: "110px",
  Asset: "100px",
  Block_Type: "150px",
  No_Of_Demand_By_Engg: "65px",
  Engg_Demand: "80px",
  No_Of_Demand_Agreed_GIVEN: "65px",
  Agreed_Demand: "80px",
  GrantedFrom: "80px",
  GrantedTo: "80px",
  Granted_Duration: "80px",
  Availed_From: "80px",
  Availed_To: "80px",
  Availed: "80px",
  Burst: "80px",
  Burst_Duration: "80px",
  Actual_Output_in_Meter: "80px",
  Actual_Output: "150px",
  Remarks: "150px",
  Granted_Not: "100px",
  Availed_Not: "100px",
  Rolling_Block: "100px",
  Remarks: "80px",
  Reason: "100px",
  Delete: "80px",
};

export const fetchGrantedNotOptions = async () => {
  try {
    const response = await axios.get(
      `${urlPrefixBlock}getTableDropDown1?table_path=B_Granted_Not`,
    );

    if (response.data.status === "ok") {
      return response.data.data;
    }
    return [];
  } catch (err) {
    console.error("Failed to fetch stations for section:", err);
    return [];
  }
};
export const fetchAvailedNotOptions = async () => {
  try {
    const response = await axios.get(
      `${urlPrefixBlock}getTableDropDown1?table_path=B_Availed_Not`,
    );

    if (response.data.status === "ok") {
      return response.data.data;
    }
    return [];
  } catch (err) {
    console.error("Failed to fetch stations for section:", err);
    return [];
  }
};
